export const updateList = [
  {
    id: "star-ring-beyond",
    title: "星环彼岸",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20spaceship%20crew%20on%20the%20bridge%20of%20a%20starship%20looking%20at%20a%20glowing%20nebula%2C%20sci-fi%20mood%2C%20detailed%20cel%20shaded%20illustration%2C%20warm%20and%20deep%20blue%20tones%2C%20clean%20background&width=800&height=450&seq=upd-c1&orientation=landscape",
    episode: 8,
    totalEpisodes: 12,
    updatedAt: "今天 20:30",
    weekday: "周三",
    genre: ["科幻", "冒险"],
    description:
      "为了寻找失踪的母舰，少年们驾驶探索船穿越星环。本集揭开了「彼岸信号」的来源，也为后续的抉择埋下伏笔。",
    episodes: [
      { no: 8, title: "第 8 集 · 彼岸的信号", date: "今天 20:30", status: "updated" },
      { no: 7, title: "第 7 集 · 静默航行", date: "10月08日", status: "updated" },
      { no: 6, title: "第 6 集 · 借来的时间", date: "10月01日", status: "updated" },
      { no: 5, title: "第 5 集 · 星环的阴影", date: "09月24日", status: "updated" },
      { no: 4, title: "第 4 集 · 信标", date: "09月17日", status: "updated" },
      { no: 9, title: "第 9 集 · 尚未更新", date: "预计 10月22日", status: "upcoming" }
    ]
  },
  {
    id: "night-train",
    title: "夜行列车",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20detective%20investigating%20a%20rainy%20neon%20alley%20at%20night%20with%20a%20flashlight%2C%20moody%20atmosphere%2C%20detailed%20cel%20shaded%20art%2C%20orange%20highlights%20against%20navy%20shadows%2C%20clean%20background&width=800&height=450&seq=upd-c2&orientation=landscape",
    episode: 11,
    totalEpisodes: 13,
    updatedAt: "昨天 21:00",
    weekday: "周二",
    genre: ["悬疑", "剧情"],
    description:
      "列车每一次停站，都会带走一名乘客的记忆。本集主角终于看清了站台上那张熟悉的脸，却付出了沉重的代价。",
    episodes: [
      { no: 11, title: "第 11 集 · 终点之前", date: "昨天 21:00", status: "updated" },
      { no: 10, title: "第 10 集 · 空座位", date: "10月06日", status: "updated" },
      { no: 9, title: "第 9 集 · 第七站", date: "09月29日", status: "updated" },
      { no: 8, title: "第 8 集 · 检票员", date: "09月22日", status: "updated" },
      { no: 12, title: "第 12 集 · 尚未更新", date: "预计 10月20日", status: "upcoming" }
    ]
  },
  {
    id: "blade-of-dawn",
    title: "破晓之刃",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20fiery%20martial%20artist%20unleashing%20an%20energy%20attack%20on%20a%20mountain%20arena%2C%20dynamic%20motion%2C%20detailed%20cel%20shaded%20art%2C%20dramatic%20warm%20lighting%2C%20orange%20and%20navy%20palette%2C%20clean%20background&width=800&height=450&seq=upd-c3&orientation=landscape",
    episode: 24,
    totalEpisodes: 24,
    updatedAt: "周一 19:00",
    weekday: "周一",
    genre: ["热血", "战斗"],
    description:
      "全篇迎来终章。主角与昔日的挚友在破晓时分做出最后的对决，关于「守护」的答案在此刻揭晓。",
    episodes: [
      { no: 24, title: "第 24 集 · 破晓（完结）", date: "周一 19:00", status: "updated" },
      { no: 23, title: "第 23 集 · 最后一式", date: "10月05日", status: "updated" },
      { no: 22, title: "第 22 集 · 旧友", date: "09月28日", status: "updated" },
      { no: 21, title: "第 21 集 · 山雨", date: "09月21日", status: "updated" }
    ]
  },
  {
    id: "spring-rain-letter",
    title: "春日雨信",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20style%20scene%20of%20a%20high%20school%20girl%20and%20boy%20sharing%20an%20umbrella%20under%20warm%20spring%20rain%2C%20romantic%20slice%20of%20life%2C%20detailed%20cel%20shaded%20illustration%2C%20soft%20cinematic%20light%2C%20orange%20and%20navy%20tones%2C%20clean%20background&width=800&height=450&seq=upd-c4&orientation=landscape",
    episode: 6,
    totalEpisodes: 12,
    updatedAt: "周日 18:30",
    weekday: "周日",
    genre: ["恋爱", "日常"],
    description:
      "梅雨季里，两个人共享一把伞的距离悄悄改变。本集没有激烈的冲突，只有一封迟到了三年的信。",
    episodes: [
      { no: 6, title: "第 6 集 · 迟到的信", date: "周日 18:30", status: "updated" },
      { no: 5, title: "第 5 集 · 同一个站台", date: "10月04日", status: "updated" },
      { no: 4, title: "第 4 集 · 借来的伞", date: "09月27日", status: "updated" }
    ]
  },
  {
    id: "ember-dragon",
    title: "余烬之龙",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20illustration%20of%20a%20dragon%20rider%20soaring%20above%20a%20volcanic%20valley%20at%20dusk%2C%20epic%20fantasy%20scene%2C%20detailed%20cel%20shaded%20art%2C%20dramatic%20warm%20lighting%2C%20orange%20and%20deep%20blue%20palette%2C%20clean%20background&width=800&height=450&seq=upd-c5&orientation=landscape",
    episode: 3,
    totalEpisodes: 12,
    updatedAt: "周六 22:00",
    weekday: "周六",
    genre: ["奇幻", "冒险"],
    description:
      "龙族的最后一枚蛋即将孵化。本集主角在火山口做出抉择，也第一次直面自己真正想要守护的东西。",
    episodes: [
      { no: 3, title: "第 3 集 · 火山口", date: "周六 22:00", status: "updated" },
      { no: 2, title: "第 2 集 · 余烬", date: "10月03日", status: "updated" },
      { no: 1, title: "第 1 集 · 蛋", date: "09月26日", status: "updated" }
    ]
  }
];